// 과정 카드의 "분야(seed)" 배지에 쓰는 포인트색.
// 포인트색은 카드·태그처럼 좁은 자리에서만 쓰고, 본문·배경에는 쓰지 않습니다.
// 의미색(green/amber/red) 및 대표색(brand)과 겹치지 않도록 별도 계열을 씁니다.

const SEED_COLOR: Record<string, string> = {
  웹개발: "rose",
  인공지능: "lime",
  딥러닝: "lime",
  데이터분석: "orange",
  파이썬: "orange",
};

const CHIP_CLASS: Record<string, string> = {
  rose: "bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300",
  lime: "bg-lime-50 text-lime-700 dark:bg-lime-900/30 dark:text-lime-300",
  orange: "bg-orange-50 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300",
};

const DEFAULT_CLASS =
  "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300";

export function getSeedChipClass(seed: string): string {
  const key = SEED_COLOR[seed];
  return key ? CHIP_CLASS[key] : DEFAULT_CLASS;
}